import { render, staticRenderFns } from "./ViewTransfer.vue?vue&type=template&id=8ae59500&scoped=true"
import script from "./ViewTransfer.vue?vue&type=script&lang=js"
export * from "./ViewTransfer.vue?vue&type=script&lang=js"
import style0 from "./ViewTransfer.vue?vue&type=style&index=0&id=8ae59500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae59500",
  null
  
)

export default component.exports